export class InvoiceHistoryLog {
    id: number;
    company_id: number;
    invoice_type: string;
    state: string;
    issuer_nif: string;
    invoice_series_number: string;
    invoice_issue_date: string;
    third_party_name: string;
    third_party_nif: string;
    total_base_amount: number;
    total_tax_amount: number;
    total_amount: number;
    chain_hash: string;
    invoice_registration_date: string;
    external_invoice_number?: string;
    verifactu_error_msj: string;
    verifactu_status_code: number;
    auto_send_to_verifactu: boolean;
    error_to_show: string;
    info_verifactu: string;

    constructor(data: any) {
        this.id = data.id
        this.company_id = data.company_id;
        this.invoice_type = data.invoice_type;
        this.state = data.state;
        this.issuer_nif = data.issuer_nif;
        this.invoice_series_number = data.invoice_series_number;
        this.invoice_issue_date = data.invoice_issue_date;
        this.third_party_name = data.third_party_name;
        this.third_party_nif = data.third_party_nif;
        this.total_base_amount = data.total_base_amount;
        this.total_tax_amount = data.total_tax_amount;
        this.total_amount = data.total_amount;
        this.chain_hash = data.chain_hash;
        this.invoice_registration_date = data.register_generation_dt || '';
        this.external_invoice_number = data.external_invoice_number || null;
        this.verifactu_error_msj = data.verifactu_error_msj;
        this.verifactu_status_code = data.verifactu_status_code;
        this.auto_send_to_verifactu = data.auto_send_to_verifactu || false;
        this.error_to_show = data.error_to_show || '';
        this.info_verifactu = data.info_verifactu || '';
    }
}